import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Highlights() {
  return (
    <section className="intro_section p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
            <h2 style={{ color: "#000" }}>
              The <span style={{ color: "#2B8FE8" }}>Highlights</span>
            </h2>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto offset-xl-1 offset-lg-1"
          >
            <p>
              While creating the new and improved website for Oz Leasing, we
              integrated some of the best features such as Lease Calculator,
              ZOHO CRM, EDMUNDS API, and Lease Order, to make sure the users
              have a top-notch experience.
            </p>
          </Col>
        </Row>
      </Container>
      <Row>
        <Col
          xs={12}
          md={10}
          lg={10}
          xl={10}
          xxl={10}
          className="m-auto text-center mt-3 d-none d-md-block"
        >
          <StaticImage
            src="../../../images/case-studies/oz-leasing/highligts_img.webp"
            alt="TekRevol"
            layout="constrained"
            placeholder="blurred"
            formats={["webp"]}
            width={1393}
            height={938}
          />
        </Col>
      </Row>
    </section>
  );
}

export default Highlights;
